<!-- ============ TOP UTILITY BAR (WHITE THEME) ============ -->
<div id="top-header">
  <div class="container-fluid px-xl-4 px-xxl-5">
    <div class="utility-content">

      <!-- Left side: Contact Info -->
      <div class="contact-info">
        <span class="info-item">
          <i class="fa-solid fa-envelope orange-icon"></i>
          <span class="label">Email</span>
          <span class="value">vgcsmk@gmail.com</span>
        </span>
        <span class="info-item">
          <i class="fa-solid fa-location-dot orange-icon"></i>
          <span class="label">Location</span>
          <span class="value">New Grain Market Samalkha, Distt. Samalkha, Haryana-132101</span>
        </span>
      </div>

      <!-- Right side: Social & Language -->
      <div class="social-connect">
        <span class="connect-text">Connect With Us</span>
        <div class="social-icons">
          <a href="https://www.facebook.com/people/Vaish-Girls-College-Samalkha/100057027476705/" target="_blank"
            title="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
          <a href="https://twitter.com/" target="_blank" title="Twitter"><i class="fa-brands fa-twitter"></i></a>
          <a href="https://www.youtube.com/" target="_blank" title="YouTube"><i class="fa-brands fa-youtube"></i></a>
          <a href="https://www.linkedin.com/" target="_blank" title="LinkedIn"><i
              class="fa-brands fa-linkedin-in"></i></a>
        </div>

        <!-- Subtle Language Toggle -->
        <!-- <button class="lang-toggle-btn" (click)="triggerTranslate()" [title]="isHindi ? 'Switch to English' : 'Switch to Hindi'">
          {{ isHindi ? 'English' : 'हिंदी' }}
        </button> -->
      </div>

    </div>
  </div>
</div>

<!-- ============ MAIN CORE NAVIGATION ============ -->
<header id="main-header" [class.scrolled]="isScrolled">
  <nav class="navbar">
    <div class="container-fluid px-xl-4 px-xxl-5">

      <!-- LOGO -->
      <a class="navbar-brand" routerLink="/" (click)="closeMobileMenu()">
        <img src="/assets/img/logo/3.png" alt="Vaish Girls College" />
      </a>

      <!-- MOBILE RIGHT SIDE: Hamburger & Search -->
      <div class="mobile-actions">
        <button class="mobile-search-btn" (click)="toggleSearch()" aria-label="Search">
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>
        <button class="navbar-toggler" type="button" [class.active]="mobileMenuOpen" (click)="toggleMobileMenu($event)"
          aria-label="Toggle navigation" [attr.aria-expanded]="mobileMenuOpen">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>

      <div class="mobile-overlay" [class.show]="mobileMenuOpen" aria-hidden="true"></div>

      <!-- MAIN MENU DRAWER & NAVIGATION -->
      <div class="navbar-collapse" [class.show]="mobileMenuOpen" id="mainMenu" [attr.aria-hidden]="!mobileMenuOpen">

        <!-- Mobile drawer header -->
        <div class="drawer-header">
          <img src="/assets/img/logo/4.png" alt="VGC" class="drawer-logo" />
          <button class="drawer-close" type="button" (click)="closeMobileMenu()" aria-label="Close menu">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <ul class="navbar-nav main-nav">

          <!-- 1. HOME -->
          <li class="nav-item">
            <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMobileMenu()">
              Home
            </a>
          </li>

          <!-- 2. ABOUT US -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('about')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('about', $event)">
              About Us <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/about-us/governing-body" (click)="closeMobileMenu()">Governing
                  Body</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/president-message"
                  (click)="closeMobileMenu()">President Message</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/principal-message"
                  (click)="closeMobileMenu()">Principal Message</a></li>
            </ul>
          </li>

          <!-- 3. AISHE -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('aishe')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('aishe', $event)">
              AISHE <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="assets/pdf/aishe/2018.pdf" target="_blank"
                  (click)="closeMobileMenu()">2018</a></li>
              <li><a class="dropdown-item" href="assets/pdf/aishe/2019.pdf" target="_blank"
                  (click)="closeMobileMenu()">2019</a></li>
              <li><a class="dropdown-item" href="assets/pdf/aishe/2020.pdf" target="_blank"
                  (click)="closeMobileMenu()">2020</a></li>
              <li><a class="dropdown-item" href="assets/pdf/aishe/2021.pdf" target="_blank"
                  (click)="closeMobileMenu()">2021</a></li>
              <li><a class="dropdown-item" href="assets/pdf/aishe/2022.pdf" target="_blank"
                  (click)="closeMobileMenu()">2022</a></li>
            </ul>
          </li>

          <!-- 4. ACADEMIC -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('academic')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('academic', $event)">
              Academic <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/academic/courses" (click)="closeMobileMenu()">Courses</a></li>
              <li><a class="dropdown-item" href="" target="_blank" (click)="closeMobileMenu()">Result</a></li>
              <li><a class="dropdown-item" href="" target="_blank" (click)="closeMobileMenu()">Fee
                  Structure</a></li>
            </ul>
          </li>

          <!-- 5. COLLEGE STAFF -->
          <li class="nav-item">
            <a class="nav-link" routerLink="/college-staff" routerLinkActive="active" (click)="closeMobileMenu()">
              College Staff
            </a>
          </li>

          <!-- 6. CAMPUS -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('campus')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('campus', $event)">
              Campus <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/campus/nss" (click)="closeMobileMenu()">NSS</a></li>
              <li><a class="dropdown-item" routerLink="/campus/women-cell" (click)="closeMobileMenu()">Women Cell</a>
              </li>
              <li><a class="dropdown-item" routerLink="/campus/anti-raging" (click)="closeMobileMenu()">Anti-Raging</a>
              </li>
            </ul>
          </li>

          <!-- 7. ADMISSION -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('admission')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('admission', $event)">
              Admission <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/admission/norms" (click)="closeMobileMenu()">Terms &amp;
                  Norms</a></li>
              <li><a class="dropdown-item" href="" target="_blank" (click)="closeMobileMenu()">Admission Dates</a>
              </li>
              <li><a class="dropdown-item" href="" target="_blank" (click)="closeMobileMenu()">Admission
                  Schedule UG</a></li>
            </ul>
          </li>

          <!-- 8. CONTACT US -->
          <li class="nav-item">
            <a class="nav-link" routerLink="/contact-us" routerLinkActive="active" (click)="closeMobileMenu()">
              Contact Us
            </a>
          </li>

          <!-- Mobile Only: Apply for Principal -->
          <li class="nav-item mobile-only-apply">
            <a class="nav-link apply-nav-link" routerLink="/apply-online" (click)="closeMobileMenu()">
              <i class="fa-solid fa-file-signature me-2"></i> Apply for Principal
            </a>
          </li>

          <!-- 9. DESKTOP SEARCH ICON -->
          <li class="nav-item search-nav-item">
            <button class="desktop-search-btn" (click)="toggleSearch()" aria-label="Search site">
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          </li>

        </ul>

      </div><!-- end navbar-collapse -->
    </div>
  </nav>
</header>

<!-- Vertical Floating Enquiry Button -->
<div class="side-enquiry-btn" *ngIf="showApplyButton">
  <a routerLink="/apply-online" class="enquiry-link">
    APPLY ONLINE FOR THE POST OF PRINCIPAL
  </a>
</div>

<!-- Mobile Sticky Bottom Bar -->
<div class="mobile-sticky-apply-bar" *ngIf="showApplyButton">
  <a routerLink="/apply-online" class="mobile-apply-link">
    <i class="fa-solid fa-graduation-cap me-2"></i> APPLY ONLINE FOR THE POST OF PRINCIPAL
  </a>
</div>


<!-- Search Overlay — HOME ONLY -->
<div class="search-overlay" [class.active]="searchOpen" (click)="closeSearch($event)" *ngIf="isHome">
  <div class="search-container" (click)="$event.stopPropagation()">
    <div class="search-box">
      <input type="text" [(ngModel)]="searchQuery" (input)="onSearchChange()" (keyup.enter)="doSearch()"
        placeholder="Search the website..." class="search-input">
      <button (click)="doSearch()" class="search-submit"><i class="fa-solid fa-magnifying-glass"></i></button>
      <button (click)="toggleSearch()" class="search-close"><i class="fa-solid fa-xmark"></i></button>
    </div>

    <!-- Search Results Dropdown -->
    <div class="search-results-wrapper" *ngIf="searchQuery">
      <div *ngIf="searchResults.length > 0">
        <div class="search-result-item" *ngFor="let result of searchResults">
          <a *ngIf="result.path.endsWith('.pdf'); else routeLink" [href]="result.path" target="_blank"
            (click)="closeSearchDirectly()">
            <span class="result-category">{{ result.category }}</span>
            <span class="result-title">{{ result.title }}</span>
            <span class="result-desc">{{ result.description }}</span>
          </a>
          <ng-template #routeLink>
            <a [routerLink]="result.path" (click)="closeSearchDirectly()">
              <span class="result-category">{{ result.category }}</span>
              <span class="result-title">{{ result.title }}</span>
              <span class="result-desc">{{ result.description }}</span>
            </a>
          </ng-template>
        </div>
      </div>
      <div class="no-results-msg" *ngIf="searchResults.length === 0">
        <i class="fa-solid fa-magnifying-glass"></i>
        <span>No results found for "{{ searchQuery }}"</span>
      </div>
    </div>
  </div>
</div>